import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";
import {
  VisuallyHiddenStyled,
  type VisuallyHiddenProps,
} from "./VisuallyHiddenStyled";
import { VisuallyHiddenTailwind } from "./VisuallyHiddenTailwind";

export const VisuallyHiddenHybrid = (props: VisuallyHiddenProps) => {
  if (needsStyledComponents(props)) {
    return <VisuallyHiddenStyled {...props} />;
  }

  return <VisuallyHiddenTailwind {...props} />;
};
